import InteractyClient from './InteractyClient'

/**
 * Immediately invoked function when script execute
 * The method call a callback function that pass as query parameter in URI.
 * Example: https://p.interacty.me/v1/sdk.umd.development.js?callback=postInit
 * Use this hook for initialize Interacty client after script loading
 */
(function postInitHook(): void {
    if (typeof window === 'undefined') return

    if (document.currentScript && 'src' in document.currentScript) {
        const srcUrl = new URL(document.currentScript.src)
        const queryParams = new URLSearchParams(srcUrl.search);
        const callbackName = queryParams.get('callback')
        if (callbackName) {
            // @ts-ignore
            let callbackIsDefined = callbackName in window && typeof window[callbackName] === "function"
            if (!callbackIsDefined)
                throw Error("Callback function can't find in global space. Name of function: " + callbackName)
            // @ts-ignore
            const callback = window[callbackName] as Function
            try {
                callback(InteractyClient)
            } catch (ex) {
                console.error(ex)
            }
        }
    }
})()
